import React, { useState, useEffect, useRef } from "react";
import {
  FaBed,
  FaClipboardList,
  FaConciergeBell,
  FaChevronDown,
  FaChevronUp,
  FaUsers,
  FaUserTie,
  FaTags,
  FaMoneyBillWave,
  FaChartBar,
  FaCog,
  FaHome,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { GiOrganigram } from "react-icons/gi";
import { SiRemovedotbg } from "react-icons/si";
import logo from "../../assets/logo-white.png";
import smalllogo from "../../assets/yellow-logo.png";

export default function SuperadminSideNav({ open, toggle }) {
  const [openPackages, setOpenPackages] = useState(false);
  const [openHotel, setOpenHotel] = useState(false);

  const startX = useRef(0);

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    if (startX.current - endX > 80) toggle();
  };

  // const navheadercss = {
  //   backgroundColor: "white",
  // };

  useEffect(() => {
    if (!open) {
      setOpenPackages(false);
      setOpenHotel(false);
    }
  }, [open]);

  return (
    <div
      className={`sidenav ${open ? "open" : "collapsed"}`}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="sidenav-header">
        <div className="d-flex justify-content-center align-items-center">
          <img
            src={open ? logo : smalllogo}
            alt="App Logo"
            className="img-fluid"
            style={{
              maxWidth: open ? "160px" : "55px",
              transition: "all 0.3s ease",
            }}
          />
        </div>
      </div>

      <div className="sidenav-menu">
        <ul className="menu">
          <li>
            <NavLink
              to="/superadmin/home"
              end
              data-label="Home"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaHome size={20} /> <span className="text">Home</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/superadmin/organization"
              data-label="Organizations"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <GiOrganigram size={20} />
              <span className="text">Organization</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/superadmin/amenity"
              data-label="Amenity"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaConciergeBell size={20} />{" "}
              <span className="text">Amenity</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/superadmin/bookings"
              data-label="Bookings"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaClipboardList size={20} />
              <span className="text">Bookings</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/superadmin/rooms"
              data-label="Rooms"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaBed size={20} /> <span className="text">Rooms</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/superadmin/guests"
              data-label="Guests"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaUsers size={20} /> <span className="text">Guests</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/superadmin/staff"
              data-label="Staff"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaUserTie size={20} /> <span className="text">Staff</span>
            </NavLink>
          </li>

          <li>
            <div
              className="menu-parent"
              onClick={() => open && setOpenPackages(!openPackages)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                padding: "12px 20px",
                cursor: "pointer",
                color: "#ffffff",
              }}
            >
              <FaTags size={20} />
              <span className="text">Packages</span>
              {open && (
                <span style={{ marginLeft: "auto" }}>
                  {openPackages ? (
                    <FaChevronUp size={14} />
                  ) : (
                    <FaChevronDown size={14} />
                  )}
                </span>
              )}
            </div>

            {open && openPackages && (
              <ul
                className="submenu"
                style={{
                  listStyle: "none",
                  paddingLeft: "55px",
                  paddingTop: "6px",
                }}
              >
                <li>
                  <NavLink
                    to="/category"
                    className={({ isActive }) => (isActive ? "active" : "")}
                    style={{
                      color: "#d1f3f6",
                      fontSize: "13px",
                      padding: "8px 0",
                      display: "block",
                      paddingLeft: "10px",
                    }}
                  >
                    <SiRemovedotbg /> Category
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/packages"
                    className={({ isActive }) => (isActive ? "active" : "")}
                    style={{
                      color: "#d1f3f6",
                      fontSize: "13px",
                      padding: "8px 0",
                      display: "block",
                      paddingLeft: "10px",
                    }}
                  >
                    <SiRemovedotbg /> Packages
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          <li>
            <NavLink
              to="/payments"
              data-label="Payments"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaMoneyBillWave size={20} />
              <span className="text">Payments</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/enquiry"
              data-label="Enquiry"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaChartBar size={20} /> <span className="text">Enquiry</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/settings"
              data-label="Settings"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaCog size={20} />
              <span className="text">Settings</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}
